<template>
  <tr>
    <td class="text-center">
      <a class="small interactive-cursor text-info" @click="editNavImage()">
      <img
        class="db-icon-img" 
        :src="app.AppIcon ? 'https://s3-ap-southeast-2.amazonaws.com/roscon/' + app.AppIcon.objectKey : require('../../assets/appicons/placeholder.jpg')" 
        alt="Roscon Admin" />
        <br/>
        [ Change ]
        </a>
    </td>
    <td data-label="Name">
      {{ app.name }} <em v-if="app.client">(Client app)</em>
    </td>
    <td>
      <button v-if="app.AppSetting" class="my-2 btn btn-info" @click="editAppSettings()">
        <i class="fa fa-cog" /> Settings
      </button>
    </td>
  </tr>
</template>

<script>
  import {
      UPLOAD_APP_ICON
    } from '@/vuex/types'
  export default {
    name: 'appRow',
    props: {
      object: {
        type: Object
      },
      index: {
        type: Number
      }
    },
    computed: {
      app () {
        return {
          ...this.object
        }
      }
    },
    methods: {
      editAppSettings () {
        this.$emit('edit', { permalink: 'editAppSettings', uuid: this.app.AppSetting.uuid })
      },
      async editNavImage () {
        await this.$store.dispatch(UPLOAD_APP_ICON, this.app.uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/App.vue